interface AdminNavBadgeProps {
  count: number | undefined;
  label: string;
}

/**
 * Small primary-burgundy pill rendered next to an admin sidebar item label.
 * Hidden when count is 0 or undefined (no zero-state flash). Renders `99+`
 * past 99. Includes an aria-label naming the entity, since the number on its
 * own doesn't say what it's counting.
 */
export const AdminNavBadge = ({ count, label }: AdminNavBadgeProps) => {
  if (!count || count <= 0) return null;
  const display = count > 99 ? '99+' : String(count);
  return (
    <span
      aria-label={`${count} pending ${label} ${count === 1 ? 'item' : 'items'}`}
      className="ml-2 inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-primary-700 text-white text-xs font-semibold"
    >
      {display}
    </span>
  );
};
